export const ORGANIZATION_TYPES = ['病院', '診療所', '歯科診療所', '看護関連施設', '薬局関連施設', '福祉・介護関連施設', '公共機関', 'その他の事業所']
